import { useCallback } from 'react';
import useNavigateToNextStep from '|/hooks/use-navigate-to-next-step';

interface UnavailableModalProps {
  onClose: () => void;
}

const useUnavailableVm = ({ onClose }: UnavailableModalProps) => {
  const navigateToNextStep = useNavigateToNextStep();

  const handleCloseModal = useCallback(() => {
    onClose();
    navigateToNextStep();
  }, [onClose, navigateToNextStep]);

  return {
    handleCloseModal
  };
};

export default useUnavailableVm;
